/* eslint-disable */
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import SiteHeader from './SiteHeader';
import Main from './Main';
import SiteFooter from './SiteFooter';
import Media from 'react-media';
import { AppNav } from 'components/navigation';
import { AuthContext } from 'components/AuthProvider';
import styled from '@emotion/styled';
import { QUOTE_VERSION_V2 } from 'constants/common';

// the height of the page minus the top and bottom bars
const StyledDiv = styled('div')`
  height: calc(100vh - 64px);
  overflow-y: auto;
  position: relative;
  z-index: 0;
`;

export const PageShell = ({ children, location, isPetInsurancePage, quoteVersion = QUOTE_VERSION_V2 }) => (
  <AuthContext.Consumer>
    {({ authenticated }) => (
      <Media query={`(max-width: ${768 / 16}em)`}>
        {(smallScreen) => {
          const Wrapper = authenticated && smallScreen ? StyledDiv : Fragment;
          return (
            <Fragment>
              <SiteHeader location={location} quoteVersion={quoteVersion} />
              <Wrapper>
                <Main>{children}</Main>
                <SiteFooter isPetInsurancePage={isPetInsurancePage} location={location} />
              </Wrapper>
              {authenticated && smallScreen && <AppNav />}
            </Fragment>
          );
        }}
      </Media>
    )}
  </AuthContext.Consumer>
);

PageShell.propTypes = {
  children: PropTypes.any,
  quoteVersion: PropTypes.string,
};

export default PageShell;
